import styled from 'styled-components'

const HeroContainer = styled.div`
margin-top: -120px;
position: relative;
`

export default HeroContainer;